<template>
  <div>
    <div class="content_box">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">我的包裹</el-breadcrumb-item> -->
        <el-breadcrumb-item><a @click="$router.back(-1)">未入库包裹</a></el-breadcrumb-item>
        <el-breadcrumb-item>更改物品信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">修改包裹物品信息</div>
      </div>
      <div class="step_three">
        <div class="operating_button_box">
          <div class="operating_button_l">
            <div class="operating_button_l_l" @click="addBox">+添加箱号</div>
            <div class="operating_button_l_l color_2" @click="delBox">
              -删除箱号
            </div>
          </div>
        </div>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="(items, indexs) in box"
            :label="indexs"
            :value="indexs"
            :key="indexs"
          >
            <div class="table_box">
              <div class="table_item">
                <div class="table_item_title_l">
                  <div class="input_frg">
                    <div class="case_number">箱号{{ indexs + 1 }}</div>
                    <div
                      style="width: 70%; display: flex"
                      class=""
                      v-if="isfromchina == 0"
                    >
                      <el-select
                        @change="selectGoods"
                        v-model="value"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入物品中文名称"
                        :remote-method="remoteMethod"
                        :loading="loading"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.name"
                                    :value="JSON.stringify(item)"
                        >
                        </el-option>
                      </el-select>
                   

                      <el-button
                        class="button_L"
                        @click="searchGoods(indexs)"
                        type="primary"
                        >搜索</el-button
                      >
                    </div>
                  </div>
                  <div class="operating_button_l_l" @click="addPackage(indexs)">
                    +添加内件
                  </div>
                </div>
                <div
                  class="table_item_box"
                  v-for="(item, index) in items.itemVoList"
                  :key="index"
                >
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">内件名称</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.name"
                        type="text"
                        placeholder="请输入物品中文名称"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">申报价值</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                           min="0"
                        v-model="item.claimprice"
                        type="number"
                        placeholder="请输入申报价值"
                        class="table_item_input"
                      />
                      <span style="margin-left:5px"> RMB</span>
                    </div>
                  </div>
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">品牌</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.brand"
                        type="text"
                        placeholder="请输入品牌"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">数量</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.count"
                             min="1"
                        type="number"
                        placeholder="请输入数量"
                        class="table_item_input"
                      />
                    </div>
                  </div>
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r" v-if="isfromchina == 1">
                      <div class="fill_in_title">材质</div>
                      <div class="fill_in_title_l">*</div>
                      <el-select
                        v-model="item.material"
                        class="input_select_table"
                        placeholder="请选择材质"
                      >
                        <el-option
                          v-for="item in cities"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="table_item_box_l_r" v-if="isfromchina == 0">
                      <div class="fill_in_title">规格</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.format"
                        type="text"
                        placeholder="请输入规格"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">种类</div>
                      <div class="fill_in_title_l">*</div>
                      <el-select
                        value-key="name"
                        class="input_select_table"
                        v-model="item.category"
                        placeholder="请选择种类"
                      >
                        <el-option
                          v-for="item in kindData"
                          :key="item.Item"
                          :label="item.Item"
                          :value="item.Item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div>
                    <div>
                      <el-upload
                      action='#'
                 :limit='limit'
                        class="avatar-uploader"
                        accept=".png,.jpg"
                        :http-request="(file)=>{return uploadHttpRequest(file,indexs,index)}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess(indexs,index)"
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="item.photoUrl"
                          :src="item.photoUrl"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </div>
                  <div>
                    <div
                      class="operating_button_l_l color_2"
                      @click="delPackage(indexs, index)"
                    >
                      -删除
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="step_box_s">
        <el-button
          type="primary"
          :loading="loading"
          round
          class="last_step_l margin_right"
          @click="submit"
          >确认</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import AWS from "aws-sdk";
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      value:[],
      limit:1,
      loading: false,
      checkedCities: [],
      box: [
        {
          itemVoList: [
            {
              brand: "",
              category: "",
              claimprice: "",
              count: "",
              englishname: "",
              format: "",
              name: "",
              photoUrl: "",
              material: "",
            },
          ],
        },
      ],

      cities: [
        "金属",
        "木质",
        "棉麻",
        "塑料",
        "玻璃",
        "针织",
        "皮革",
        "纤维",
        "液体",
        "纸质",
        "石质",
        "硅胶",
        "食品",
        "药品",
        "化学材料",
      ],
      goodsData: "",
      orderId: "",
      kindData: [],
      isfromchina: "",
      boxData: [],
      itemVoListIndex:'',
      boxIndex:'',
      options:[]
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.isfromchina = this.$route.query.isfromchina;
    this.kind(this.$route.query.routeid);
    this.boxList(this.orderId)
  },
  methods: {
      handleAvatarSuccess(indexs,index) {
  
    },
    beforeAvatarUpload() {},
     //上传图片
       uploadHttpRequest(param,indexs,index) {
       this.itemVoListIndex=index;
      this.boxIndex=indexs;
      var that = this;
      var credentials = {
        accessKeyId: "AKIAJEPDGNAK3LSG4D7Q",
        secretAccessKey: "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",
      };
      AWS.config.update(credentials);
      AWS.config.region = "us-east-1"; //设置区域
      var bucket = new AWS.S3({ params: { Bucket: "eplus-ex" } }); //选择桶
            var ksy = Number(new Date()) + Math.random().toString(36).substr(2);
      var params = {
        methods: "put",
        Body: param.file,
    Key: 'order/'+ksy+'/'+param.file.name,
        ContentType: param.file.type,
        "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      bucket.upload(params, function (err, data) {
        if (data) {
          that.box[that.boxIndex].itemVoList[that.itemVoListIndex].photoUrl = data.Location;
      
        }
      });
    },
       //箱子
    boxList(id) {
      var data = {
        orderid: id,
      };
      crudDept.boxList(data).then((res) => {
        if(res.content != ''){
          this.box=res.content
        }
      });
    },
    //选择种类
    selectCategory(e) {
    },
    //商品种类
    kind(id) {
      var data = {
        id:id
      };
      crudDept.circuit(data).then((res) => {
        this.kindData = JSON.parse(res.content[0].price);
      });
    },
    //提交数据
    submit() {
      var that = this;

      var data = {
        id: Number(that.orderId),
        orderbaggageVoList: this.box,
      };
      for (var i = 0; i < this.box.length; i++) {
        if (this.box[i].itemVoList == "") {
          this.$message({
            showClose: true,
            message: "箱号不能为空",
            type: "warning",
          });
          return false;
        }
        for (var j = 0; j < this.box[i].itemVoList.length; j++) {
          if (this.box[i].itemVoList[j].name == "") {
            this.$message({
              showClose: true,
              message: "请输入内件名称",
              type: "warning",
            });
            return false;
          }
          if (this.box[i].itemVoList[j].brand == "") {
            this.$message({
              showClose: true,
              message: "请输入品牌名称",
              type: "warning",
            });
            return false;
          }

          if (this.isfromchina == 1) {
            if (this.box[i].itemVoList[j].material == "") {
              this.$message({
                showClose: true,
                message: "请选择材质",
                type: "warning",
              });
              return false;
            }
          } else {
            if (this.box[i].itemVoList[j].format == "") {
              this.$message({
                showClose: true,
                message: "请输入规格",
                type: "warning",
              });
              return false;
            }
          }

          if (this.box[i].itemVoList[j].claimprice == "") {
            this.$message({
              showClose: true,
              message: "请输入申报价值",
              type: "warning",
            });
            return false;
          }
          if (this.box[i].itemVoList[j].count == "") {
            this.$message({
              showClose: true,
              message: "请输入数量",
              type: "warning",
            });
            return false;
          }
          if (this.box[i].itemVoList[j].category == "") {
            this.$message({
              showClose: true,
              message: "请选择种类",
              type: "warning",
            });
            return false;
          }
        }
      }
      that.loading = true;
      crudDept
        .updateOrder(data)
        .then((res) => {
          setTimeout(() => {
            that.loading = false;
            that.$message({
              message: "操作成功",
              type: "success",
            });
          }, 1500);

          this.dialogVisible = false;
          this.orderList();
              that.$router.go(-1);

        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleCheckedCitiesChange(e) {
      var data = this.box;
      var datas = [];
      for (var j = 0; j < e.length; j++) {
        datas.push(data[e[j]]);
      }
      this.boxData = datas;
    },
    //点击删除箱号
    delBox() {
      var data = this.box;
      var checkedCities = this.boxData;
      var leg = data.length;
      for (var i = 0; i < leg; i++) {
        for (var j = 0; j < checkedCities.length; j++) {
          if (data[i]) {
            if (data[i] == checkedCities[j]) {
              data.splice(i, 1);
            }
          }
        }
      }
      this.boxData = [];
      this.checkedCities = [];
    },
    //点击添加箱号
    addBox() {
      var data = {
        itemVoList: [
          {
            brand: "",
            category: "",
            material: "",
            claimprice: "",
            count: "",
            englishname: "",
            format: "",
            name: "",
            photoUrl: "",
          },
        ],
      };
      this.box = this.box.concat(data);
    },

    //选中物品
    selectGoods(e) {
        e = JSON.parse(e);

      var data = {
        brand: e.brand,
        category:  e.category,
        material: "",
        claimprice: "",
        count: "",
        englishname: "",
        format: e.format,
        name: e.name,
        photoUrl: "",
      };

      this.goodsData = data;
    },
    //点击搜索物品
    searchGoods(indexs) {
      var data = this.box[indexs].itemVoList.concat(this.goodsData);
      this.box[indexs].itemVoList = data;
    },
    //搜索物品
    remoteMethod(e) {
      var data = {
        name: e,
        page: 1,
        size: 50,
      };
      crudDept.goods(data).then((res) => {
        this.options = res.content;
      });
    },
    //删除内件
    delPackage(indexs, index) {
      var data = this.box[indexs].itemVoList;
      data.splice(index, 1);
    },
    //添加内件
    addPackage(index) {
      var datas = {
        brand: "",
        categoryid: "",
        claimprice: "",
        count: "",
        englishname: "",
        format: "",
        name: "",
        photoUrl: "",
      };
      var data = this.box[index].itemVoList.concat(datas);
      this.box[index].itemVoList = data;
    },
  },
};
</script>
<style scoped>
.el-checkbox {
  margin-bottom: 20px;
}
.last_step_l {
  width: 150px;
  height: 44px;
  /* background: #5178ff; */
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px !important;
  border-radius: 22px;
  margin: 0 20px !important;
  padding: 0 !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  line-height: 91px;
  text-align: center;
}
.input_frg {
  display: flex;
  align-items: center;
}
.avatar {
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  display: block;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.color_2 {
  border: 1px solid #ffa401 !important;
  color: #ffa401 !important;
}
.content_box_title {
  margin-top: 45px;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.operating_button_box {
  display: flex;
  justify-content: flex-end;
  padding-right: 48px;
  box-sizing: border-box;
  margin-bottom: 15px;
}
.operating_button_l {
  display: flex;
}
.operating_button_l_l {
  width: 117px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #5178ff;
  opacity: 1;
  border-radius: 8px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  margin-left: 12px;
  color: #5178ff;
}
.step_three {
  /* width: 90%; */

  box-sizing: border-box;
}
.table_box {
  width: 100%;
  height: auto;
  display: flex;
}
.table_item {
  width: 100%;
  height: auto;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
}
.table_item_title_l {
  display: flex;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  align-items: center;
}
.case_number {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2e3136;
  margin-right: 30px;
}
.table_item_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  border-top: 1px solid #e1e1e1;
}
.table_item_box_l {
  margin-right: 50px;
}
.table_item_box_l_r {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 10px;
}
.table_item_input >>> .el-input__inner {
  background: transparent;
  border: none !important;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  border: none !important;
  font-weight: 400;
}
.input_select_table {
  background: #f1f3f6 !important;
  padding: 0 !important;
  width: 180px;
  height: 40px;
  background: #f1f3f6;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.input_select_table >>> .el-input__inner {
  background: transparent;
  border: none !important;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.margin_right {
  margin-right: 0 !important;
}
.inout_uio {
  width: 502px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px 0 0 5px;
  padding: 0 15px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/parcel/productInformation.vue